import { withResolvedError } from '@wix/members-area-commons-ts';

import type { ErrorHandler, HttpClient } from '../../types/controller';

const CHAT_SETTINGS_URL = '/_api/crm-inbox-server/chat/settings/members';

type ChatSettingsResponse = { enabled: boolean };

type ChatSettingsServiceOptions = {
  httpClient: HttpClient;
  errorHandler: ErrorHandler;
};

export class ChatSettingsService {
  private readonly httpClient: HttpClient;
  private readonly errorHandler: ErrorHandler;

  constructor({ httpClient, errorHandler }: ChatSettingsServiceOptions) {
    this.httpClient = httpClient;
    this.errorHandler = errorHandler;
  }

  readonly getIsSocialChat = async (): Promise<boolean> => {
    const requestFn = () =>
      this.httpClient.get<ChatSettingsResponse>(CHAT_SETTINGS_URL);

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return Boolean(data?.enabled);
  };
}
